'use client'

import { type Project, FeaturedProjectsBlock } from '@/payload-types'
import React from 'react'
import { CMSLink } from '@/components/Link'
import RichText from '@/components/RichText'
import { Section } from '@/components/Section'
import { GrantsCallout } from './GrantsCallout'
import { Heading } from '@/components/ui/heading'
import { Eyebrow } from '@/components/Eyebrow'
import { ShardGrid } from '@/components/ShardGrid'
import { ProjectCard } from '@/components/ProjectCard'
import { GrantStats } from './GrantStats'

export function FeaturedProjectsClient(props: {
  projects: Project[]
  heading: FeaturedProjectsBlock['heading']
  description: FeaturedProjectsBlock['description']
  link: FeaturedProjectsBlock['link']
  grants: FeaturedProjectsBlock['grants']
}) {
  const { projects, heading, description, link, grants } = props
  return (
    <Section className="h-full relative text-light" bgClassName="bg-paper-1">
      <div className="flex flex-col gap-[50px]">
        <div className="flex flex-col lg:flex-row gap-[80px] justify-between">
          <div className="flex flex-col max-w-[600px]">
            <Eyebrow variant="dark" label="Builder community" color="zest" className="mb-[50px]" />
            <Heading size="h2" className="text-dark mb-[30px] text-balance">
              {heading}
            </Heading>
            {description && <RichText className="prose-dark max-w-[500px]" data={description} />}
            <div className="mt-[30px]">{link && <CMSLink {...link} />}</div>
          </div>
          <div className="hidden lg:block flex-1">
            <ShardGrid />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-[10px] gap-y-[50px] py-[30px]">
          {projects.map((project) => (
            <ProjectCard
              variant="dark"
              key={project.id}
              project={project}
              aspectRatio="5/4"
              imageClassName="w-full h-[200px] md:w-[240px] md:h-auto"
            />
          ))}
        </div>
      </div>
      <div className="pt-[30px] flex flex-col lg:flex-row gap-[30px] justify-between">
        <GrantsCallout description={grants.description} link={grants.link} className="flex-1" />
        <GrantStats
          eyebrow={grants.eyebrow}
          projectCount={grants.projectCount}
          usdDeployed={grants.usdDeployed}
          size="md"
        />
      </div>
    </Section>
  )
}
